import "./EmptyLayout.css";
import type { FC, PropsWithChildren } from "react";

export const EmptyLayout: FC<PropsWithChildren> = (props) => {
  return <div className="layout-empty">{props.children}</div>;
};
